import React, { useState } from 'react';
import { imagePath } from '@common/services/images-service';

const bgImages = [
  './auth-mountains.jpg',
  './auth-ocean.jpg',
  './auth-sea.jpg',
  './auth-sunset.jpg',
  './auth-terrain.jpg',
  './auth-beach.jpg',
  './auth-canyon.jpg',
  './auth-forest.jpg',
  './auth-lake.jpg',
  './auth-sakura.jpg',
];

export const LoginBackgrounds = () => {
  const [idx, setIdx] = useState(() =>
    Math.floor(Math.random() * bgImages.length)
  );

  const nextImage = () => {
    setIdx((idx + 1) % bgImages.length);
  };

  return (
    <div onClick={nextImage}>
      <style jsx>{`
        div {
          min-height: 100vh;
          background-size: cover;
          width: 100%;
          background-image: url('${imagePath(bgImages[idx])}');
        }
      `}</style>
    </div>
  );
};
